import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Confirm from "../../assets/images/sign-up/subscription_confirm.png";

import { Congratulations } from "./styles";

function CongratulationsComp() {
  const { t } = useTranslation();
  const { ticket } = useSelector((state) => state.customerServiceReducer);

  return (
    <Congratulations>
      <div>
        <div className="bigBox">
          <h3>{t("TICKET_TITLE")}</h3>
          <img src={Confirm} alt="Confirm" />
          <p>
            {t("TICKET_MESSAGE")}
            <br /> {t("TICKET_NUMBER")}:
          </p>
          <span>{ticket.id}</span>
        </div>
      </div>
      <div className="container">
        <div className="buttons">
          <Link to={`/customer-service/ticketDetail`}>
            <button type="button">{t("TICKET_VIEW")}</button>
          </Link>
        </div>
      </div>
    </Congratulations>
  );
}

export default CongratulationsComp;
